import { FORM_SETTINGS_ACTIVE_ICONS, FORM_SETTINGS_INACTIVE_ICONS } from './settings.constants';

export function getFormSettingIcon(key: string, active = false): string {
  return active ? FORM_SETTINGS_ACTIVE_ICONS[key] : FORM_SETTINGS_INACTIVE_ICONS[key];
}
